export { POLICY_PAGES, policyBySlug } from '../../seed/policy.mjs';
